import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bowler-registration-form" }

import { ref } from 'vue'

import FormButton from '@/components/common/FormButton.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import BowlerRegistration from '@/utils/bowler-registration'

/* local state */


export default /*@__PURE__*/_defineComponent({
  __name: 'BowlerRegistrationRequestForm',
  setup(__props) {

const formEmail = ref<string>('')
const isError = ref<boolean>(false)
const isLoading = ref<boolean>(false)
const isSuccess = ref<boolean>(false)

/* actions */

const submit = async (): Promise<void> => {
  isLoading.value = true

  const isRequestSuccessful = await BowlerRegistration.requestRegistration(
    formEmail.value ?? '',
  )

  isSuccess.value = isRequestSuccessful
  isError.value = !isRequestSuccessful
  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isSuccess.value & !isError.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 0,
          message: 
        _ctx.$t('bowler-registration.request-succeeded-message', {
          email: formEmail.value,
        })
      ,
          "is-success": ""
        }, null, 8, ["message"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (isError.value)
            ? (_openBlock(), _createBlock(NotificationBanner, {
                key: 0,
                message: _ctx.$t('bowler-registration.request-failed-error'),
                "is-danger": ""
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            autocomplete: "off",
            spellcheck: "false",
            onSubmit: _withModifiers(submit, ["prevent"])
          }, [
            _createVNode(FormTextInput, {
              modelValue: formEmail.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formEmail).value = $event)),
              name: "email",
              type: "email",
              label: _ctx.$t('field-labels.email'),
              "is-disabled": isLoading.value,
              "is-required": ""
            }, null, 8, ["modelValue", "label", "is-disabled"]),
            _createVNode(FormButton, {
              "is-busy": isLoading.value,
              "is-disabled": formEmail.value.length < 1
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('bowler-registration.submit')), 1)
              ]),
              _: 1
            }, 8, ["is-busy", "is-disabled"])
          ], 32)
        ], 64))
  ]))
}
}

})